import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=31f8f36a&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"
import style0 from "./PeopleList.vue?vue&type=style&index=0&id=31f8f36a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8f36a",
  null
  
)

export default component.exports